import React, { useEffect, useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import api from "../lib/api";
import Header from "../components/app/Header";
import { Wrench, Users, Activity, KeyRound, MessageSquare, BookOpen, Radio } from "lucide-react";

const Tab = ({ to, icon: Icon, children, testid, badge }) => (
  <NavLink
    to={to}
    data-testid={testid}
    end
    className={({ isActive }) =>
      `inline-flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-medium border transition-colors ${
        isActive
          ? "bg-emerald-500/10 text-emerald-300 border-emerald-500/30"
          : "bg-transparent text-zinc-400 border-zinc-800 hover:text-white hover:border-zinc-700"
      }`
    }
  >
    <Icon className="w-4 h-4" />
    {children}
    {badge != null && badge > 0 && (
      <span className="ml-0.5 text-[10px] font-mono px-1.5 py-0.5 rounded bg-amber-500/15 text-amber-200 border border-amber-500/30">
        {badge}
      </span>
    )}
  </NavLink>
);

export default function AdminLayout() {
  const [pendingResets, setPendingResets] = useState(0);
  useEffect(() => {
    const load = () =>
      api
        .get("/admin/password-resets", { params: { status: "pending", _: Date.now() } })
        .then((r) => setPendingResets(r.data.length))
        .catch(() => {});
    load();
    const onFocus = () => load();
    window.addEventListener("focus", onFocus);
    const t = setInterval(load, 60_000);
    return () => {
      window.removeEventListener("focus", onFocus);
      clearInterval(t);
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
          <div>
            <div className="text-[11px] uppercase tracking-[0.3em] text-amber-300/80 mb-2">
              // control room
            </div>
            <h1 className="font-display text-4xl md:text-5xl tracking-tighter font-black">
              Admin Console
            </h1>
            <p className="text-zinc-500 text-sm mt-2">
              Manage agents, members, and observe usage across the hub.
            </p>
          </div>
          <div className="flex items-center gap-2 flex-wrap">
            <Tab to="/admin/tools" icon={Wrench} testid="admin-tab-tools">
              Tools
            </Tab>
            <Tab to="/admin/users" icon={Users} testid="admin-tab-users">
              Users
            </Tab>
            <Tab
              to="/admin/conversations"
              icon={MessageSquare}
              testid="admin-tab-conversations"
            >
              Conversations
            </Tab>
            <Tab
              to="/admin/participants"
              icon={Users}
              testid="admin-tab-participants"
            >
              Participants
            </Tab>
            <Tab
              to="/admin/knowledge"
              icon={BookOpen}
              testid="admin-tab-knowledge"
            >
              Knowledge
            </Tab>
            <Tab
              to="/admin/resets"
              icon={KeyRound}
              testid="admin-tab-resets"
              badge={pendingResets}
            >
              Resets
            </Tab>
            <Tab to="/admin/logs" icon={Activity} testid="admin-tab-logs">
              Usage Logs
            </Tab>
            <Tab
              to="/admin/cross-hub-access"
              icon={Radio}
              testid="admin-tab-cross-hub-access"
            >
              Cross-hub access
            </Tab>
          </div>
        </div>
        <Outlet />
      </div>
    </div>
  );
}
